import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportAgent } from "../../../api/callcenters/service"
import { callExportAgent } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import reports from '../../../data/reportAgent'
import { callGetAllProvince } from "../../../api/settings/service";
import DatePicker from "react-datepicker";
import SmartTable from "../../../components/common/table-component";
const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', reportType: 0, reportValue: "north", provinceId: '', startDate: '', endDate: '' });
	const [agentList, setAgentList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [provinceList, setProvinceList] = useState([]);

	useEffect(() => {
		loadData();
		loadProvince();

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, reportType: request.reportType, reportValue: request.reportValue, provinceId: request.provinceId, startDate: request.startDate, endDate: request.endDate };
		console.log(data)
		const rsp = await dispatch(callGetExportAgent(data));
		if (rsp?.payload?.responseCode === "00000") {
			setAgentList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};
	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};


	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectReportType = (e) => {
		setRequest((prev) => ({
			...prev,
			reportType: e.target.value,
		}));
	}

	const selectReportValue = (e) => {
		setRequest((prev) => ({
			...prev,
			reportValue: e.target.value,
		}));
	}

	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: totalRecord, keyword: request.keyword, reportType: request.reportType, reportValue: request.reportValue, provinceId: request.provinceId, startDate: request.startDate, endDate: request.endDate };
			let response = await callExportAgent(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text328", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("report.agent.name")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={request.startDate}
														onChange={date => setRequest((prev) => ({
															...prev,
															startDate: moment(date).format('YYYY-MM-DD'),
														}))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={request.endDate}
														onChange={date => setRequest((prev) => ({
															...prev,
															endDate: moment(date).format('YYYY-MM-DD'),
														}))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('report.customer.reportTypeName')}</label>
													<select className="chosen-single form-select"
														onChange={selectReportType}
														value={request.reportType}
													>
														{
															reports.reportType.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												{
													request.reportType == 1 ?
														<div className="col-md-3 form-group">
															<label>{t('report.customer.region.name')}</label>
															<select className="chosen-single form-select"
																onChange={selectReportValue}
																value={request.reportValue}
															>
																{
																	reports.region.map((item) => (
																		<option key={item.key} value={item.key}>{t(item.name)}</option>
																	))
																}
															</select>
														</div> : null
												}
												{request.reportType != 1 && < div className="col-md-2 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>}
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "callcenter.agent.agentCode", key: "agentCode", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.gender", key: "gender", render: (val) => t('gender.' + val) },
							{ labelKey: "callcenter.agent.firstName", key: "firstName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.lastName", key: "lastName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : <span className="badge bg-danger">{t('status.inActive')}</span> },
							{ labelKey: "callcenter.agent.phone", key: "phone" },
							{ labelKey: "callcenter.agent.isVerify", key: "isVerify", render: (val) => val === 1 ? <span className="badge bg-success">{t('verifyStatus.verify')}</span> : <span className="badge bg-danger">{t('verifyStatus.notVerify')}</span> },
							{ labelKey: "callcenter.agent.agentType", key: "configCommissionId", render: (val) => val == 1 ? t("agentType.life") : val == 2 ? t("agentType.vehicle") : t("agentType.all") },
							{ labelKey: "callcenter.agent.dateOfBirth", key: "dateOfBirth", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "report.agent.region.name", key: "region" },
							{ labelKey: "callcenter.agent.provinceName", key: "provinceName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.districtName", key: "districtName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.village", key: "village", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.agent.documentType", key: "documentName" },
							{ labelKey: "callcenter.agent.documentNo", key: "documentNo" },
							{ labelKey: "callcenter.agent.issueDate", key: "issueDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.agent.issuePlace", key: "issuePlace" },
							{ labelKey: "callcenter.agent.expiredDate", key: "expiredDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.agent.modifiedDate", key: "updatedAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "callcenter.agent.modifiedBy", key: "updatedBy" },
						]}
	data={{ result: agentList }}
	rowKey="agentId"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	rowNumberOffset={(request.page - 1) * request.maxResult}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
